// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Pr-z","imageAndVideoCount":"Qr-z","imageAndVideoContainer":"Rr-z","viewAllReviews":"Sr-z"};